// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"Withdrawal_cardFooter__E7wX3","minValue":"Withdrawal_minValue__qOy1P"};